import React, { type JSX } from 'react';
import classnames from 'classnames';
import { objectUtils } from '@codametrix/ui-common';
import FeatureMapping from './case-evidence-mapping';
import { cmxArtifacts, cmxTypeguards } from '@codametrix/ui-common';
import { PropertyAccessor } from './propery-accessor';

const { getFeatureForSelection, isSingleSelection, isLinkable } = cmxArtifacts;
const { isCategorical, isNgram } = cmxTypeguards;

export const NA = 'N/A';

const onlyType = (items: CMxArtifacts.FeatureSelection[]) => {
  return items.filter(item => {
    const feature = getFeatureForSelection(item);
    return (
      (isSingleSelection(item) &&
        (isCategorical(feature) || isNgram(feature))) ??
      false
    );
  });
};

export const propAccessor = (
  detail: CMxAPI.CaseRun,
  evidenceManager: CMxCommonApp.EvidenceManager
): PropertyAccessor => {
  return (propPath: string, altValue: any = NA) => {
    const prop = objectUtils.get(detail, propPath, altValue);
    const evidenceKey = FeatureMapping[propPath];
    // no evidence may be sought, if so, just return the value
    if (evidenceKey === undefined) {
      return prop !== null ? prop : altValue;
    }
    const notLinked = !isLinkable(evidenceKey);
    // check to see if we have any highlights
    const isHighlighted = evidenceManager.isHighlighted(evidenceKey);

    if (notLinked || !isHighlighted) {
      return prop !== null ? prop : altValue;
    }

    const isSelected = evidenceManager.isSelected(evidenceKey);
    const highlights = evidenceManager.getHighlights(
      evidenceKey
    ) as CMxArtifacts.FeatureSelection[];

    if (highlights === undefined) {
      return prop;
    }
    // deal with categorical evidence only at this time
    const categoricals = onlyType(highlights);
    if (!categoricals.length) {
      return prop;
    }

    // wrap the value in spans for particular codes
    let highlighted: JSX.Element = prop;
    categoricals.forEach(categorical => {
      if (isSingleSelection(categorical) && !categorical.evidence) {
        return;
      }
      const styleClasses = [
        `evidence`,
        'highlighted-text',
        {
          'evidence-categorical': true,
          'qa-evidence-categorical': true,
          'evidence-active': isSelected,
          'qa-evidence-active': isSelected
        },
        `evidence-${categorical.codeType.toLowerCase()}`
      ];
      highlighted = (
        <span className={classnames(styleClasses)}>{highlighted}</span>
      );
    });
    return highlighted;
  };
};
